import { request } from '@/utils/request'

function requestPublic(options) {
  return request({
    ...options,
    headers: {
      ...(options.headers || {}),
      isToken: false
    }
  })
}

// 资讯/指南列表。type=1 用药指导，type=2 临床指南。
export function informationList(params) {
  return requestPublic({
    url: '/literature/information/list',
    method: 'get',
    params
  })
}

// Android 中部分分类场景使用 POST 查询指南列表。
export function informationListPost(data) {
  return requestPublic({
    url: '/literature/information/list',
    method: 'post',
    data
  })
}

// 临床指南、用药指导、临床评分详情。
export function informationDetail(id) {
  return requestPublic({
    url: `/literature/information/${id}`,
    method: 'get'
  })
}

// 医学知识库详情。
export function syKbDetail(id) {
  return requestPublic({
    url: `/literature/syKb/getById/${id}`,
    method: 'get'
  })
}

// 用药指导、临床指南分类树。
export function informationCategoryTree(params) {
  return requestPublic({
    url: '/literature/informationCategory/getTree',
    method: 'get',
    params
  })
}

// 用药指导、临床指南分类列表。
export function informationCategoryList(params) {
  return requestPublic({
    url: '/literature/informationCategory/getList',
    method: 'get',
    params
  })
}

// 知识库内容分页。
export function syKbPage(params) {
  return requestPublic({
    url: '/literature/syKb/page',
    method: 'get',
    params
  })
}

// 知识库分类列表。
export function categoryGetList(params) {
  return requestPublic({
    url: '/literature/category/getList',
    method: 'get',
    params
  })
}

// 知识库分类树，用于发病部位、就诊科室筛选。
export function categoryGetTree(params) {
  return requestPublic({
    url: '/literature/category/getTree',
    method: 'get',
    params
  })
}

// 常见症状/症状搜索。
export function extentList(params) {
  return requestPublic({
    url: '/base/extent/list',
    method: 'get',
    params
  })
}

// 病症图谱，根据症状查询疾病。
export function knowledgeAtlasQuery(data) {
  return requestPublic({
    url: '/literature/knowledgeAtlas/query',
    method: 'post',
    data
  })
}

// 病症图谱疾病详情。
export function knowledgeAtlasDetail(id) {
  return requestPublic({
    url: `/literature/knowledgeAtlas/${id}`,
    method: 'get'
  })
}
